


// import React, { useRef, useState, useLayoutEffect } from "react";
// import { motion, useScroll, useTransform } from "framer-motion";

// import ServiceCardStack from "../components/services/ServiceCardStack";

// const NAV_HEIGHT_PX = 180;
// const MAX_HEADLINE_SHIFT = 130;

// const Services = () => {
//   const sectionRef = useRef(null);
//   const headlineRef = useRef(null);
//   const [headlineHeight, setHeadlineHeight] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);

//   // Detect screen size
//   useLayoutEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   // Measure headline
//   useLayoutEffect(() => {
//     const el = headlineRef.current;
//     if (!el) return;
//     const resizeObserver = new ResizeObserver(() => {
//       setHeadlineHeight(el.offsetHeight);
//     });
//     resizeObserver.observe(el);
//     setHeadlineHeight(el.offsetHeight);
//     return () => resizeObserver.disconnect();
//   }, []);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   const headlineY = useTransform(
//     scrollYProgress,
//     [0, 0.02],
//     [0, -Math.min(MAX_HEADLINE_SHIFT, Math.round(headlineHeight * 0.75))]
//   );

//   const cardsTop = NAV_HEIGHT_PX + headlineHeight + 8;

//   return (
//     <section ref={sectionRef} className="relative bg-[#FFFFFF] px-[24px] md:px-[75px]">
//       {/* ✅ Headline */}
//       {isMobile ? (
//         // 📱 On mobile: normal flow, no sticky, no animation
//         <div className="w-full flex justify-start mb-6 mt-[130px]  ">
//           <h2 className="text-[28px]   font-garamond-subheading-services text-[#2C3075] text-left w-full max-w-[1280px] leading-snug">
//             Comprehensive care to support you at every stage of recovery.
//           </h2>
//         </div>
//       ) : (
//         // 💻 On desktop: sticky + animated
//         <motion.div
//           ref={headlineRef}
//           className="sticky left-0 md:px-[75px] px-0 w-full z-30 flex justify-start"
//           style={{
//             top: `${NAV_HEIGHT_PX}px`,
//             y: headlineY,
//           }}
//         >
//           <h2 className="text-[48px] font-garamond-subheading-services text-[#2C3075] text-left w-full max-w-[1280px] leading-snug">
//             Comprehensive care to support you at every stage of recovery.
//           </h2>
//         </motion.div>
//       )}

//       {/* ✅ Cards */}
//       <ServiceCardStack scrollYProgress={scrollYProgress} cardsTopPx={cardsTop} />
//     </section>
//   );
// };

// export default Services;





import React, { useRef, useState, useLayoutEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

import ServiceCardStack from "../components/services/ServiceCardStack";

const NAV_HEIGHT_PX = 180;
const MAX_HEADLINE_SHIFT = 130;

const Services = () => {
  const sectionRef = useRef(null);
  const headlineRef = useRef(null);
  const [headlineHeight, setHeadlineHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useLayoutEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Measure headline
  // useLayoutEffect(() => {
  //   const el = headlineRef.current;
  //   if (!el) return;
  //   const resizeObserver = new ResizeObserver(() => {
  //     setHeadlineHeight(el.offsetHeight);
  //   });
  //   resizeObserver.observe(el);
  //   setHeadlineHeight(el.offsetHeight);
  //   return () => resizeObserver.disconnect();
  // }, []);

  // const { scrollYProgress } = useScroll({
  //   target: sectionRef,
  //   offset: ["start start", "end end"],
  // });

  // const headlineY = useTransform(
  //   scrollYProgress,
  //   [0, 0.02],
  //   [0, -Math.min(MAX_HEADLINE_SHIFT, Math.round(headlineHeight * 0.75))]
  // );

  const cardsTop = NAV_HEIGHT_PX + headlineHeight + 8;

  return (
    <section  className="relative bg-[#FFFFFF] px-[24px] md:px-[75px] w-full">
      {/* ✅ Headline */}
      {isMobile ? (
        // 📱 On mobile: normal flow, no sticky, no animation
        <div className="w-full flex justify-center items-center mb-6 mt-[130px]  ">
          <h2 className="text-[28px]   font-garamond-subheading-services text-[#2C3075] text-center  w-full max-w-[1280px] leading-snug">
            Comprehensive care to support you at every stage of recovery.
          </h2>
        </div>
      ) : (
        // 💻 On desktop: sticky + animated
        // <motion.div
        //   ref={headlineRef}
        //   className="sticky left-0 md:px-[75px] px-0 w-full z-30 flex justify-start"
        //   style={{
        //     top: `${NAV_HEIGHT_PX}px`,
        //     y: headlineY,
        //   }}
        // >
        //   <h2 className="text-[48px] font-garamond-subheading-services text-[#2C3075] text-left w-full max-w-[1280px] leading-snug">
        //     Comprehensive care to support you at every stage of recovery.
        //   </h2>
          // </motion.div>
          

          <div className="w-full flex justify-center items-center mb-[80px] mt-[130px]  ">
          <h2 className="text-[28px] text-center  font-garamond-subheading-services text-[#2C3075]  w-full max-w-[1280px] leading-snug">
            Comprehensive care to support you at every stage of recovery.
          </h2>
        </div>
      )}

      {/* ✅ Cards */}
      <ServiceCardStack  />
    </section>
  );
};

export default Services;
